import React, { useState, useEffect } from 'react';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { getWmsAlmacenes, getWmsUbicaciones, createWmsUbicacion, printZPL, getWarehousesByUser, getWmsImpresorasByAlmacen } from '../../api.wms';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import EtiquetaDocument from '../../components/EtiquetaDocument';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import IconButton from '@mui/material/IconButton';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import MenuItem from '@mui/material/MenuItem';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../contexts/AuthContext';

const WmsUbicaciones = () => {
  const { userRole } = useAuth();
  const [activeItem, setActiveItem] = useState('ubicaciones');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const [masivo, setMasivo] = useState({ pasillos: 1, ubicacionesPorPasillo: 1, niveles: 1, posicionesPorNivel: 1, almacen_id: '' });
  const [individual, setIndividual] = useState({ pasillo: 1, niveles: 1, posicionesPorNivel: 1, almacen_id: '' });
  const [preview, setPreview] = useState([]);
  const [modalEtiquetaOpen, setModalEtiquetaOpen] = useState(false);
  const [ubicacionEtiqueta, setUbicacionEtiqueta] = useState(null);
  const [barcodeBase64, setBarcodeBase64] = useState(null);
  const [qrBase64, setQrBase64] = useState(null);
  const [modalImpresionOpen, setModalImpresionOpen] = useState(false);
  const [impresion, setImpresion] = useState({ pasilloInicial: '', ubicacionInicial: '', pasilloFinal: '', ubicacionFinal: '', zona: '' });
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState('');
  const [almacenesDisponibles, setAlmacenesDisponibles] = useState([]);
  const [userWarehouses, setUserWarehouses] = useState([]);
  const [impresoras, setImpresoras] = useState([]);
  const [impresoraSeleccionada, setImpresoraSeleccionada] = useState('');

  useEffect(() => {
    const fetchUserWarehouses = async () => {
      const userId = localStorage.getItem('userId');
      if (userId) {
        try {
          const almacenes = await getWarehousesByUser(userId);
          setUserWarehouses(almacenes);
        } catch {
          setUserWarehouses([]);
        }
      }
    };
    fetchUserWarehouses();
  }, []);

  useEffect(() => {
    const fetchAlmacenes = async () => {
      try {
        let data = await getWmsAlmacenes();
        // Si el usuario no es admin, filtrar solo los almacenes asignados
        if (userRole !== 'admin' && userWarehouses.length > 0) {
          data = data.filter(a => userWarehouses.includes(a.id));
        }
        setAlmacenesDisponibles(data);
      } catch {
        setAlmacenesDisponibles([]);
      }
    };
    fetchAlmacenes();
  }, [userRole, userWarehouses]);

  useEffect(() => {
    if (!almacenSeleccionado) return;
    const fetchUbicaciones = async () => {
      try {
        const data = await getWmsUbicaciones();
        setUbicaciones(data.filter(u => String(u.almacen_id) === String(almacenSeleccionado)));
      } catch (error) {
        setUbicaciones([]);
      }
    };
    fetchUbicaciones();
  }, [almacenSeleccionado]);

  useEffect(() => {
    if (!almacenSeleccionado) return;
    const fetchImpresoras = async () => {
      try {
        const data = await getWmsImpresorasByAlmacen(almacenSeleccionado);
        setImpresoras(data);
        if (data.length > 0) setImpresoraSeleccionada(data[0].id);
      } catch {
        setImpresoras([]);
        setImpresoraSeleccionada('');
      }
    };
    fetchImpresoras();
  }, [almacenSeleccionado]);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => { setModalOpen(false); setPreview([]); };
  const handleTabChange = (e, v) => { setTab(v); setPreview([]); };

  // Generar previsualización masiva con lados A y B y código formateado
  const handlePreviewMasivo = () => {
    const arr = [];
    const pasillos = Number(masivo.pasillos) || 1;
    const ubicacionesPorPasillo = Number(masivo.ubicacionesPorPasillo) || 1;
    const niveles = Number(masivo.niveles) || 1;
    const posicionesPorNivel = Number(masivo.posicionesPorNivel) || 1;
    const almacen_id = masivo.almacen_id;
    // Cada pasillo tiene ubicaciones a ambos lados (A y B)
    const ubicPorLado = Math.floor(ubicacionesPorPasillo / 2);
    // Aquí deberías obtener los números reales de pasillo del backend si existen
    // Por ahora, se asume que los números son consecutivos desde 1
    for (let p = 1; p <= pasillos; p++) {
      for (let lado of ['A', 'B']) {
        for (let u = 1; u <= ubicPorLado; u++) {
          for (let n = 1; n <= niveles; n++) {
            for (let pos = 1; pos <= posicionesPorNivel; pos++) {
              arr.push({
                codigo: `${String(p).padStart(3, '0')}-${lado}-${String(u).padStart(3, '0')}-${String(n).padStart(3, '0')}-${String(pos).padStart(3, '0')}`,
                tipo: 'Rack',
                zona: `P${p}`,
                nivel: n,
                posicion: pos,
                lado,
                almacen_id
              });
            }
          }
        }
      }
    }
    setPreview(arr);
  };
  // Generar previsualización individual with lados A y B
  const handlePreviewIndividual = () => {
    const arr = [];
    const pasillo = Number(individual.pasillo) || 1;
    const niveles = Number(individual.niveles) || 1;
    const posicionesPorNivel = Number(individual.posicionesPorNivel) || 1;
    const almacen_id = individual.almacen_id;
    // Aquí deberías obtener el número real de pasillo del backend si existe
    for (let lado of ['A', 'B']) {
      for (let n = 1; n <= niveles; n++) {
        for (let pos = 1; pos <= posicionesPorNivel; pos++) {
          arr.push({
            codigo: `${String(pasillo).padStart(3, '0')}-${lado}-001-${String(n).padStart(3, '0')}-${String(pos).padStart(3, '0')}`,
            tipo: 'Rack',
            zona: `P${pasillo}`,
            nivel: n,
            posicion: pos,
            lado,
            almacen_id
          });
        }
      }
    }
    setPreview(arr);
  };

  const handleCreateUbicaciones = async () => {
    try {
      for (const ubic of preview) {
        await createWmsUbicacion({
          codigo: ubic.codigo,
          tipo: ubic.tipo,
          zona: ubic.zona,
          capacidad: null,
          almacen_id: ubic.almacen_id ? Number(ubic.almacen_id) : null,
          lado: ubic.lado
        });
      }
      setModalOpen(false);
      setPreview([]);
      const data = await getWmsUbicaciones();
      setUbicaciones(data);
    } catch (e) {
      alert('Error al crear ubicaciones');
    }
  };

  const handleOpenEtiqueta = (ubic) => {
    setUbicacionEtiqueta(ubic);
    setModalEtiquetaOpen(true);
  };

  // Generar código de barras real y QR cuando se abre el modal
  React.useEffect(() => {
    if (modalEtiquetaOpen && ubicacionEtiqueta) {
      // Código de barras
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, ubicacionEtiqueta.codigo, { format: 'CODE128', width: 2, height: 60, displayValue: false });
      const base64 = canvas.toDataURL('image/png');
      setBarcodeBase64(base64);
      // QR
      QRCode.toDataURL(ubicacionEtiqueta.codigo, { width: 60, margin: 0 }, (err, url) => {
        if (!err) setQrBase64(url);
        else setQrBase64(null);
      });
    } else {
      setBarcodeBase64(null);
      setQrBase64(null);
    }
  }, [modalEtiquetaOpen, ubicacionEtiqueta]);

  const handleCloseEtiqueta = () => {
    setModalEtiquetaOpen(false);
    setUbicacionEtiqueta(null);
  };

  // Bloque ZPL del logo Amerisa (optimizado, pequeño y centrado, más abajo)
  const ZPL_LOGO_AMERISA = `^FO324,60^GFA,1600,1600,25,gV03E,I03I01FFK0FF3KF0IFEI0IF80FF84J0C,I03J0FFJ01FC0KF03IFC007FF01IFCJ0C,I038I03F8I01F007C00F01F0FEI0F803C0FCI01E,I078I01F8I01F003C00300F03FI07803803CI01E,I078I01F8I03F003C00300F01F8007807803CI01E,I07CI01FCI03F003C00100F00FC007807001CI01F,I0FCI01FCI03F003C00100F007C007807001CI03F,I0FCI01FCI07F003C00100F007C007807I0CI03F,I0FEI01BEI06F003CK0F007C007807I0CI07F8,001DEI019EI0EF003CK0F007C007807800CI07F8,0019EI019EI0CF003CK0F007C0078078004I0678,0019FI019FI0CF003CK0F007C007807C004I0E7C,0038FI018F001CF003C00800F007C007807EL0C3C,0030FI018F8018F003C00800F00F8007807FL0C3C,0030F80018F8018F003C00800F00F8007803F8J01C3E,006078001878038F003C01800F01FI07803FEJ0181E,00607800187C030F003IF800F03EI07801FFJ0181E,00607C00187C030F003IF800F0FCI07800FFCI0381F,00C03C00183C070F003IF800IFJ078007FEI0300F,00C03C00183E060F003C01800IFJ078001FF800300F,01C03E00183E0E0F003C00800F1FJ078I0FFC00700F,01C03E00181E0E0F003C00800F0F8I078I03FC00600F8,01IFE00181F0C0F003C00800F078I078I01FE007IF8,03JF00180F1C0F003CK0F07CI078J0FE00JF8,03801F00180F980F003CK0F03EI078J07E00C007C,03I0F00180F980F003CK0F03EI07804003E00C003C,07I0F001807B80F003CK0F01FI07804001F01C003C,06I07801807F00F003CI040F01FI07804001F018001E,06I07801807F00F003CI040F00F8007806I0F018001E,0EI07801803F00F003CI0C0F00FC007806I0E038001E,0CI07C01803E00F003CI080F007C007806001E03I01F,0CI03C01803E00F003C00180F003E007807001E03J0F,1CI03E01801E00F003C00380F003F007807001C07J0F8,1CI03E01801C00F003C00780F001F007807C03C07J0F8,3CI03F01C00C01F807JF01F801F80FC07F0780FJ0FC,FF801FFDFF8080IF3KF0IF00FF7FF84IF03FE007FF,R08J03JFE0IF00FF7FF843FC,,::03K01FK0FEI01CI0FCI0IF001CI03FJ07E,078J07FCI01FF8003C001FF001IF801CI0FF8001FF,078J0FFEI03FFC003C003FF001IF801C001FFC001FF8,078I01IFI07FFE003C0078F801IF801C003FFE003C7C,078I03E0FI0FC3E003C007078I0FI01C003C1E00383C,078I03C07800F01E003C007038I0FI01C00780F00381C,078I03C07800F00E003C007018I0FI01C00780F00381C,078I07803801F006003C0078K0FI01C007807003C,078I07803C01EK03C007CK0FI01C00F002003E,078I07803C01EK03C007FCJ0FI01C00FK03FC,078I07803C01EK03C003FFJ0FI01C00FK01FF8,078I07803C01E0FE003C001FF8I0FI01C00FL0FFC,078I07803C01E1FF003CI07F8I0FI01C00FL03FC,078I07803C01E0FF003CJ07CI0FI01C00FM03E,078I07803C01E00F003C00603CI0FI01C00F00700201E,078I07803800F007003C00E03CI0FI01C00700F00701E12078I03C07800F007003C00F03CI0FI01C00780F00781E2C078I03C07800F80F003C00703CI0FI01C00781F00781E2C078I03E0FI07C1F003C00783CI0FI01C003C1E003C3E2C07FFC01IFI03IF003C007FF8I0FI01C003FFE003FFC2807FFC00FFEI03FFE003C003FF8I0FI01C001FFC001FF81,03FFC007FCJ0FFC003C001FEJ0FI01CI0FF8I0FF00C01FF8001FK03EI018I0F8J06I01CI03EJ07C,^FS`;

function generarZplEtiqueta({ codigo }) {
  // Extraer el nivel del código: formato esperado 001-A-001-001(nivel)-001
  let nivel = '';
  const partes = codigo.split('-');
  if (partes.length >= 5) {
    nivel = String(Number(partes[3])); // Elimina ceros a la izquierda
  }
  return `^XA\n^FWN\n${ZPL_LOGO_AMERISA}\n^FO40,80^BQN,2,7^FDLA,${codigo}^FS\n^CF0,50\n^FO220,190^FD${codigo}^FS\n^CF0,50\n^FO600,50^FDNivel ${nivel}^FS\n^BY2,2,60\n^FO240,280^BCN,70,Y,N,N\n^FD${codigo}^FS\n^XZ`;
  }

  const handlePrintZPL = async (ubic, impresoraParam) => {
    toast.info('Solicitando impresión de etiqueta...', { autoClose: 1500 });
    let printer = impresoraParam || impresoras.find(i => String(i.id) === String(impresoraSeleccionada));
    if (!printer) {
      toast.error('Selecciona una impresora válida.');
      return;
    }
    const zpl = generarZplEtiqueta({ codigo: ubic.codigo });
    try {
      if (printer.tipo_conexion === 'NGROK' && printer.link) {
        // Usar la función especial para NGROK
        await handlePrintZPLToCustomURL(ubic, printer.link);
        toast.success('Etiqueta enviada directamente al endpoint NGROK.');
      } else if ((printer.tipo_conexion === 'Red' || printer.tipo_conexion === 'IP') && printer.link) {
        await printZPL({ zpl, printer_ip: printer.link });
        toast.success('Etiqueta enviada a la impresora de red.');
      } else if (printer.tipo_conexion === 'WiFi' && printer.link) {
        await printZPL({ zpl, printer_ip: printer.link });
        toast.success('Etiqueta enviada a la impresora WiFi.');
      } else if (printer.tipo_conexion === 'USB') {
        await printZPLBrowserPrint(zpl);
        toast.success('Etiqueta enviada a la impresora USB.');
      } else {
        toast.error('Tipo de conexión de impresora no soportado o sin link/IP.');
      }
    } catch (e) {
      toast.error('Error al imprimir: ' + (e?.response?.data?.detail || e.message));
    }
  };

  // Modificar handlePrintZPLToCustomURL para aceptar un link opcional
  const handlePrintZPLToCustomURL = async (ubic, customLink) => {
    let url = customLink;
    if (!url) {
      url = prompt('Ingresa el endpoint base de impresión (ejemplo: https://xxxx.ngrok.io):');
      if (!url) return;
      url = url.trim().replace(/\/$/, ''); // Quita / final si lo hay
      url = url + '/print';
    } else {
      url = url.trim().replace(/\/$/, '');
      url = url + '/print';
    }
    const zpl = generarZplEtiqueta({ codigo: ubic.codigo });
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: zpl
      });
      if (!res.ok) throw new Error('Respuesta no exitosa: ' + res.status);
      toast.success('Etiqueta enviada al endpoint personalizado.');
    } catch (e) {
      if (e.message && e.message.includes('Failed to fetch')) {
        toast.info('Etiqueta enviada, pero no se pudo verificar la respuesta');
      } else {
        toast.error('Error al imprimir vía URL: ' + (e?.message || e));
      }
    }
  };

  // --- INICIO: Función para imprimir por USB usando Zebra Browser Print ---
  async function printZPLBrowserPrint(zpl) {
    return new Promise((resolve, reject) => {
      if (!window.BrowserPrint) {
        reject(new Error('Browser Print no está instalado o habilitado.'));
        return;
      }
      window.BrowserPrint.getDefaultDevice('printer', function(printer) {
        if (!printer) {
          reject(new Error('No se detectó una impresora Zebra conectada por USB.'));
          return;
        }
        printer.send(zpl, function() {
          resolve();
        }, function(error) {
          reject(new Error('Error al imprimir: ' + error));
        });
      }, function() {
        reject(new Error('No se pudo acceder a Browser Print.'));
      });
    });
  }
  // --- FIN: Función para imprimir por USB usando Zebra Browser Print ---

  // Función para imprimir ZPL usando WebUSB
  async function printZPLWithWebUSB(zpl) {
    try {
      // Solicita el dispositivo Zebra (puedes ajustar el vendorId si es necesario)
      const device = await navigator.usb.requestDevice({
        filters: [{ vendorId: 0x0A5F }] // Vendor ID de Zebra
      });
      await device.open();
      if (device.configuration === null) {
        await device.selectConfiguration(1);
      }
      await device.claimInterface(0);

      // Convierte el ZPL a bytes
      const encoder = new TextEncoder();
      const data = encoder.encode(zpl);

      // Intenta enviar por el endpoint 1 (puede variar según el modelo)
      await device.transferOut(1, data);

      await device.releaseInterface(0);
      await device.close();
      toast.success('Etiqueta enviada a la impresora por WebUSB');
    } catch (error) {
      toast.error('Error al imprimir por WebUSB: ' + error);
    }
  }

  const handleImpresionMasiva = async () => {
    const pasilloSel = impresion.pasilloInicial;
    if (!pasilloSel) {
      toast.warn('Selecciona un pasillo.');
      return;
    }
    let ubicacionesFiltradas = ubicaciones.filter(u => u.codigo.split('-')[0] === pasilloSel);
    // Ordenar igual que en la tabla
    ubicacionesFiltradas = ubicacionesFiltradas.slice().sort((a, b) => {
      const [pa, la, ua, na, posa] = a.codigo.split('-');
      const [pb, lb, ub, nb, posb] = b.codigo.split('-');
      const npa = Number(pa), npb = Number(pb);
      const nua = Number(ua), nub = Number(ub);
      const nna = Number(na), nnb = Number(nb);
      const nposa = Number(posa), nposb = Number(posb);
      if (npa !== npb) return npa - npb;
      if (la !== lb) return la.localeCompare(lb);
      if (nua !== nub) return nua - nub;
      if (nna !== nnb) return nna - nnb;
      return nposa - nposb;
    });
    if (ubicacionesFiltradas.length === 0) {
      toast.warn('No se encontraron ubicaciones en el pasillo seleccionado.');
      return;
    }
    const printer = impresoras.find(i => String(i.id) === String(impresoraSeleccionada));
    if (!printer) {
      toast.error('Selecciona una impresora válida.');
      return;
    }
    toast.info(`Enviando ${ubicacionesFiltradas.length} etiquetas a la impresora...`, { autoClose: 2000 });
    // Impresión secuencial para mantener el orden
    for (const ubic of ubicacionesFiltradas) {
      const zpl = generarZplEtiqueta({ codigo: ubic.codigo });
      try {
        if (printer.tipo_conexion === 'NGROK' && printer.link) {
          await handlePrintZPLToCustomURL(ubic, printer.link);
        } else if ((printer.tipo_conexion === 'Red' || printer.tipo_conexion === 'IP') && printer.link) {
          await printZPL({ zpl, printer_ip: printer.link });
        } else if (printer.tipo_conexion === 'WiFi' && printer.link) {
          await printZPL({ zpl, printer_ip: printer.link });
        } else if (printer.tipo_conexion === 'USB') {
          await printZPLBrowserPrint(zpl);
        } else {
          // No soportado
        }
      } catch (e) {
        // Puedes mostrar un error por cada ubicación si lo deseas
      }
    }
    toast.success(`Enviadas ${ubicacionesFiltradas.length} etiquetas a la impresora.`);
    setModalImpresionOpen(false);
  };

  // --- INICIO: Función para descargar ZPL como archivo ---
  function downloadZPL(zpl, nombre = 'etiqueta.zpl') {
    const blob = new Blob([zpl], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  }
  // --- FIN: Función para descargar ZPL como archivo ---

  // Obtener pasillos únicos disponibles
  const pasillosDisponibles = Array.from(new Set(ubicaciones.map(u => u.codigo.split('-')[0]))).sort((a, b) => Number(a) - Number(b));
  // Ubicaciones disponibles para el pasillo seleccionado
  const ubicacionesEnPasillo = ubicaciones
    .filter(u => impresion.pasilloInicial && u.codigo.split('-')[0] === impresion.pasilloInicial)
    .map(u => u.codigo.split('-')[2]);
  const ubicacionesUnicas = Array.from(new Set(ubicacionesEnPasillo)).sort((a, b) => Number(a) - Number(b));

  // Selección automática de almacén si solo hay uno asignado y no es admin
  useEffect(() => {
    if (
      userWarehouses.length === 1 &&
      userRole !== 'admin' &&
      almacenesDisponibles.length === 1 &&
      !almacenSeleccionado
    ) {
      setAlmacenSeleccionado(almacenesDisponibles[0].id);
    }
  }, [userWarehouses, userRole, almacenesDisponibles, almacenSeleccionado]);

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        {!almacenSeleccionado && (userRole === 'admin' || userWarehouses.length > 1) ? (
          <div className="flex flex-col items-center justify-center min-h-[60vh]">
            <div className="bg-white p-8 rounded shadow mt-10">
              <h2 className="text-xl font-bold mb-4">Selecciona un almacén para gestionar ubicaciones</h2>
              <select
                className="border rounded px-3 py-2 w-64"
                value={almacenSeleccionado}
                onChange={e => setAlmacenSeleccionado(e.target.value)}
              >
                <option value="">-- Selecciona un almacén --</option>
                {almacenesDisponibles.map(a => (
                  <option key={a.id} value={a.id}>{a.nombre} ({a.codigo})</option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-4">Gestión de Ubicaciones</h1>
            <p className="mb-6">Consulta y administra las ubicaciones físicas del almacén.</p>
            <div className="mb-4 flex justify-end">
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                onClick={() => setModalImpresionOpen(true)}
              >
                Impresión masiva
              </button>
            </div>
            {/* Modal de impresión masiva */}
            <Modal open={modalImpresionOpen} onClose={() => setModalImpresionOpen(false)}>
              <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, maxWidth: 400, mx: 'auto', my: 8 }}>
                <h2 className="text-lg font-bold mb-2">Impresión masiva de etiquetas</h2>
                {/* Selección de pasillo */}
                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                  <TextField
                    select
                    label="Pasillo"
                    value={impresion.pasilloInicial}
                    onChange={e => setImpresion({ ...impresion, pasilloInicial: e.target.value })}
                    fullWidth
                  >
                    {pasillosDisponibles.map(p => (
                      <MenuItem key={p} value={p}>{p}</MenuItem>
                    ))}
                  </TextField>
                </Box>
                {/* Selector de impresora */}
                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                  <TextField
                    select
                    label="Impresora"
                    value={impresoraSeleccionada}
                    onChange={e => setImpresoraSeleccionada(e.target.value)}
                    fullWidth
                    disabled={impresoras.length === 0}
                  >
                    {impresoras.length === 0 ? (
                      <MenuItem value="">No hay impresoras registradas</MenuItem>
                    ) : (
                      impresoras.map(imp => (
                        <MenuItem key={imp.id} value={imp.id}>{imp.nombre} ({imp.tipo_conexion})</MenuItem>
                      ))
                    )}
                  </TextField>
                </Box>
                <Button 
      variant="contained" 
      color="primary" 
      onClick={handleImpresionMasiva} 
      disabled={!impresion.pasilloInicial || impresoras.length === 0 || !impresoraSeleccionada}
    >Imprimir etiquetas</Button>
    <Button onClick={() => setModalImpresionOpen(false)} color="error" sx={{ ml: 2 }}>Cerrar</Button>
              </Box>
            </Modal>
            <Modal open={modalOpen} onClose={handleCloseModal}>
              <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, maxWidth: 600, mx: 'auto', my: 8 }}>
                <Tabs value={tab} onChange={handleTabChange} centered>
                  <Tab label="Creación masiva" />
                  <Tab label="Ubicación individual" />
                </Tabs>
                {tab === 0 && (
                  <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField label="Cantidad de pasillos" type="number" value={masivo.pasillos} onChange={e => setMasivo({ ...masivo, pasillos: e.target.value })} />
                    <TextField label="Ubicaciones por pasillo" type="number" value={masivo.ubicacionesPorPasillo} onChange={e => setMasivo({ ...masivo, ubicacionesPorPasillo: e.target.value })} />
                    <TextField label="Niveles por ubicación" type="number" value={masivo.niveles} onChange={e => setMasivo({ ...masivo, niveles: e.target.value })} />
                    <TextField label="Posiciones por nivel" type="number" value={masivo.posicionesPorNivel} onChange={e => setMasivo({ ...masivo, posicionesPorNivel: e.target.value })} />
                    <TextField label="ID Almacén" type="number" value={masivo.almacen_id} onChange={e => setMasivo({ ...masivo, almacen_id: e.target.value })} />
                    <Button variant="contained" color="primary" onClick={handlePreviewMasivo}>Previsualizar</Button>
                  </Box>
                )}
                {tab === 1 && (
                  <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField label="Pasillo" type="number" value={individual.pasillo} onChange={e => setIndividual({ ...individual, pasillo: e.target.value })} />
                    <TextField label="Niveles" type="number" value={individual.niveles} onChange={e => setIndividual({ ...individual, niveles: e.target.value })} />
                    <TextField label="Posiciones por nivel" type="number" value={individual.posicionesPorNivel} onChange={e => setIndividual({ ...individual, posicionesPorNivel: e.target.value })} />
                    <TextField label="ID Almacén" type="number" value={individual.almacen_id} onChange={e => setIndividual({ ...individual, almacen_id: e.target.value })} />
                    <Button variant="contained" color="primary" onClick={handlePreviewIndividual}>Previsualizar</Button>
                  </Box>
                )}
                {preview.length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <div className="font-bold mb-2">Previsualización ({preview.length} ubicaciones):</div>
                    {/* Tabla solo en pantallas medianas y grandes */}
                    <div className="hidden sm:block" style={{ maxHeight: 200, overflowY: 'auto' }}>
                      <table className="min-w-full text-xs border rounded bg-white">
                        <thead>
                          <tr>
                            <th className="px-2 py-1">Código</th>
                            <th className="px-2 py-1">Zona</th>
                            <th className="px-2 py-1">Lado</th>
                            <th className="px-2 py-1">Nivel</th>
                            <th className="px-2 py-1">Posición</th>
                          </tr>
                        </thead>
                        <tbody>
                          {preview
                            .slice()
                            .sort((a, b) => {
                              const [pa, la, ua, na, posa] = a.codigo.split('-');
                              const [pb, lb, ub, nb, posb] = b.codigo.split('-');
                              // Ordenar por pasillo, lado, ubicacion, nivel, posicion (todos numéricos menos lado)
                              const npa = Number(pa), npb = Number(pb);
                              if (npa !== npb) return npa - npb;
                              if (la !== lb) return la.localeCompare(lb);
                              const nua = Number(ua), nub = Number(ub);
                              if (nua !== nub) return nua - nub;
                              const nna = Number(na), nnb = Number(nb);
                              if (nna !== nnb) return nna - nnb;
                              const nposa = Number(posa), nposb = Number(posb);
                              return nposa - nposb;
                            })
                            .slice(0, 100)
                            .map((u, i) => (
                              <tr key={i}>
                                <td className="px-2 py-1">{u.codigo}</td>
                                <td className="px-2 py-1">{u.zona}</td>
                                <td className="px-2 py-1">{u.lado}</td>
                                <td className="px-2 py-1">{u.nivel}</td>
                                <td className="px-2 py-1">{u.posicion}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {preview.length > 100 && <div className="text-xs text-gray-500 mt-2">Mostrando solo los primeros 100 registros de {preview.length}.</div>}
                    </div>
                    {/* Cards para móviles */}
                    <div className="sm:hidden flex flex-col gap-2" style={{ maxHeight: 200, overflowY: 'auto' }}>
                      {preview
                        .slice()
                        .sort((a, b) => {
                          const [pa, la, ua, na, posa] = a.codigo.split('-');
                          const [pb, lb, ub, nb, posb] = b.codigo.split('-');
                          const npa = Number(pa), npb = Number(pb);
                          if (npa !== npb) return npa - npb;
                          if (la !== lb) return la.localeCompare(lb);
                          const nua = Number(ua), nub = Number(ub);
                          if (nua !== nub) return nua - nub;
                          const nna = Number(na), nnb = Number(nb);
                          if (nna !== nnb) return nna - nnb;
                          const nposa = Number(posa), nposb = Number(posb);
                          return nposa - nposb;
                        })
                        .slice(0, 100)
                        .map((u, i) => (
                          <div key={i} className="bg-white rounded shadow p-2 flex flex-col text-xs w-full break-words whitespace-normal">
                            <div className="font-bold mb-1 break-words whitespace-normal" style={{ wordBreak: 'break-word' }}>{u.codigo}</div>
                            <div><span className="font-semibold">Zona:</span> {u.zona}</div>
                            <div><span className="font-semibold">Lado:</span> {u.lado}</div>
                            <div><span className="font-semibold">Nivel:</span> {u.nivel}</div>
                            <div><span className="font-semibold">Posición:</span> {u.posicion}</div>
                          </div>
                        ))}
                      {preview.length > 100 && <div className="text-xs text-gray-500 mt-2">Mostrando solo los primeros 100 registros de {preview.length}.</div>}
                    </div>
                    <Button variant="contained" color="success" sx={{ mt: 2 }} onClick={handleCreateUbicaciones}>Crear ubicaciones</Button>
                  </Box>
                )}
              </Box>
            </Modal>
            <div className="overflow-x-auto">
              {/* Vista de tabla para pantallas medianas y grandes */}
              <table className="min-w-full bg-white rounded shadow hidden sm:table">
                <thead>
                  <tr>
                    <th className="px-4 py-2">Código</th>
                    <th className="px-4 py-2">Tipo</th>
                    <th className="px-4 py-2">Zona</th>
                    <th className="px-4 py-2">Capacidad</th>
                    <th className="px-4 py-2">Ocupación</th>
                    <th className="px-4 py-2">Etiqueta</th>
                  </tr>
                </thead>
                <tbody>
                  {ubicaciones
                    .slice()
                    .sort((a, b) => {
                      // Ordenar por pasillo (número), lado (string), ubicación (número), nivel (número), posición (número)
                      const [pa, la, ua, na, posa] = a.codigo.split('-');
                      const [pb, lb, ub, nb, posb] = b.codigo.split('-');
                      const npa = Number(pa), npb = Number(pb);
                      const nua = Number(ua), nub = Number(ub);
                      const nna = Number(na), nnb = Number(nb);
                      const nposa = Number(posa), nposb = Number(posb);
                      if (npa !== npb) return npa - npb;
                      if (la !== lb) return la.localeCompare(lb);
                      if (nua !== nub) return nua - nub;
                      if (nna !== nnb) return nna - nnb;
                      return nposa - nposb;
                    })
                    .map((ubic) => (
                      <tr key={ubic.id} className="border-t">
                        <td className="px-4 py-2">{ubic.codigo}</td>
                        <td className="px-4 py-2">{ubic.tipo}</td>
                        <td className="px-4 py-2">{ubic.zona}</td>
                        <td className="px-4 py-2">{ubic.capacidad}</td>
                        <td className="px-4 py-2">{ubic.ocupacion}</td>
                        <td className="px-4 py-2">
                          <IconButton color="primary" size="small" onClick={() => {
  toast(({ closeToast }) => (
    <div>
      <div>¿Deseas imprimir la etiqueta de esta ubicación?</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
        {impresoras && impresoras.length > 0 ? (
          impresoras.map((imp) => (
            <Button
              key={imp.id}
              size="small"
              color="primary"
              variant="contained"
              onClick={async () => {
                await handlePrintZPL(ubic, imp);
                closeToast();
              }}
              title={`Imprimir en ${imp.nombre} (${imp.tipo_conexion})`}
            >
              {imp.nombre}
            </Button>
          ))
        ) : (
          <span className="text-gray-500 text-xs mr-2">No hay impresoras registradas</span>
        )}
        <Button size="small" color="info" variant="outlined" onClick={() => {
          const zpl = generarZplEtiqueta({ codigo: ubic.codigo });
          downloadZPL(zpl, `etiqueta_${ubic.codigo}.zpl`);
          closeToast();
        }}>Descargar ZPL</Button>
        <Button size="small" color="error" variant="outlined" onClick={closeToast}>No</Button>
      </div>
    </div>
  ), {
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    position: 'top-center',
    toastId: `confirm-imprimir-${ubic.id}`
  });
}} title="Imprimir etiqueta">
    <LocalOfferIcon />
  </IconButton>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {/* Vista tipo cards para móviles */}
              <div className="sm:hidden flex flex-col gap-3">
                {ubicaciones
                  .slice()
                  .sort((a, b) => {
                    // Ordenar por pasillo (número), lado (string), ubicación (número), nivel (número), posición (número)
                    const [pa, la, ua, na, posa] = a.codigo.split('-');
                    const [pb, lb, ub, nb, posb] = b.codigo.split('-');
                    const npa = Number(pa), npb = Number(pb);
                    const nua = Number(ua), nub = Number(ub);
                    const nna = Number(na), nnb = Number(nb);
                    const nposa = Number(posa), nposb = Number(posb);
                    if (npa !== npb) return npa - npb;
                    if (la !== lb) return la.localeCompare(lb);
                    if (nua !== nub) return nua - nub;
                    if (nna !== nnb) return nna - nnb;
                    return nposa - nposb;
                  })
                  .map((ubic) => (
                    <div key={ubic.id} className="bg-white rounded shadow p-3 flex flex-col text-xs">
                      <div className="flex justify-between items-center mb-1">
                        <span className="font-bold">{ubic.codigo}</span>
                        <IconButton color="primary" size="small" onClick={() => {
                          toast(({ closeToast }) => (
                            <div>
                              <div>¿Deseas imprimir la etiqueta de esta ubicación?</div>
                              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
                                {impresoras && impresoras.length > 0 ? (
                                  impresoras.map((imp) => (
                                    <Button
                                      key={imp.id}
                                      size="small"
                                      color="primary"
                                      variant="contained"
                                      onClick={async () => {
                                        await handlePrintZPL(ubic, imp);
                                        closeToast();
                                      }}
                                      title={`Imprimir en ${imp.nombre} (${imp.tipo_conexion})`}
                                    >
                                      {imp.nombre}
                                    </Button>
                                  ))
                                ) : (
                                  <span className="text-gray-500 text-xs mr-2">No hay impresoras registradas</span>
                                )}
                                <Button size="small" color="info" variant="outlined" onClick={() => {
                                  const zpl = generarZplEtiqueta({ codigo: ubic.codigo });
                                  downloadZPL(zpl, `etiqueta_${ubic.codigo}.zpl`);
                                  closeToast();
                                }}>Descargar ZPL</Button>
                                <Button size="small" color="error" variant="outlined" onClick={closeToast}>No</Button>
                              </div>
                            </div>
                          ), {
                            autoClose: false,
                            closeOnClick: false,
                            draggable: false,
                            position: 'top-center',
                            toastId: `confirm-imprimir-${ubic.id}`
                          });
                        }} title="Imprimir etiqueta">
                          <LocalOfferIcon fontSize="small" />
                        </IconButton>
                      </div>
                      <div><span className="font-semibold">Tipo:</span> {ubic.tipo}</div>
                      <div><span className="font-semibold">Zona:</span> {ubic.zona}</div>
                      <div><span className="font-semibold">Capacidad:</span> {ubic.capacidad}</div>
                      <div><span className="font-semibold">Ocupación:</span> {ubic.ocupacion}</div>
                    </div>
                  ))}
              </div>
            </div>
          </>
        )}
        {/* Modal de etiqueta PDF */}
        <Modal open={modalEtiquetaOpen} onClose={handleCloseEtiqueta}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: '95vw', sm: 500 }, height: { xs: 320, sm: 350 }, bgcolor: 'background.paper', boxShadow: 24, p: 2, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              {/* Botón Imprimir ZPL */}
              {ubicacionEtiqueta && (
                <>
                  <Button
                    onClick={() => handlePrintZPL(ubicacionEtiqueta)}
                    color="primary"
                    size="small"
                    variant="contained"
                    sx={{ mr: 1 }}
                  >
                    Imprimir por IP
                  </Button>
                  <Button
                    onClick={() => {
                      const zpl = generarZplEtiqueta({ codigo: ubicacionEtiqueta.codigo });
                      downloadZPL(zpl, `etiqueta_${ubicacionEtiqueta.codigo}.zpl`);
                    }}
                    color="info"
                    size="small"
                    variant="outlined"
                    sx={{ mr: 1 }}
                  >
                    Descargar ZPL
                  </Button>
                  <Button
                    onClick={() => handlePrintZPLToCustomURL(ubicacionEtiqueta)}
                    color="secondary"
                    size="small"
                    variant="outlined"
                    sx={{ mr: 1 }}
                  >
                    Ngrok/URL
                  </Button>
                </>
              )}
              <Button onClick={handleCloseEtiqueta} color="error" size="small">Cerrar</Button>
            </Box>
            {ubicacionEtiqueta && (
              <div style={{ width: '100%', height: 250, maxWidth: '100vw' }}>
                <PDFViewer width="100%" height="100%" style={{ minWidth: 0 }}>
                  <EtiquetaDocument ubicacion={ubicacionEtiqueta} barcodeBase64={barcodeBase64} qrBase64={qrBase64} />
                </PDFViewer>
              </div>
            )}
          </Box>
        </Modal>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </div>
    </div>
  );
};

export default WmsUbicaciones;
